
            const data = {"name":"idea-plus","data":{"width":"24","height":"24","viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M13 5a1 1 0 1 0-2 0v6H5a1 1 0 1 0 0 2h6v6a1 1 0 1 0 2 0v-6h6a1 1 0 1 0 0-2h-6V5Z\" _fill=\"#336DFF\"/>","originalColors":[{"type":"fill","color":"#336DFF"}],"stopColors":[]}}
        
                    module.exports = data
                    